module.exports = __webpack_public_path__ + "static/jennifer-43efd9f10c24fcb787f276e716a28573.jpg";